export default __webpack_public_path__ + "static/media/1461.b4fc9141.png";